import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import type { CreateCategoryInput, UpdateCategoryInput } from "@montatec/contracts"
import { CacheKeys } from "../../../shared/consts/keys.consts"
import { tagsService } from "./tags.service"

export function useTags(categoryId: number | null) {        
    return useQuery({
        queryKey: CacheKeys.tags(categoryId!),
        queryFn: () => tagsService.get(categoryId!),
        enabled: categoryId !== null
    })
}

export function useTagsMutations() {
    const qc = useQueryClient()

    const createTag = useMutation({
        mutationFn: ({categoryId, data } : {categoryId: number, data: CreateCategoryInput}) => tagsService.create(categoryId, data),
        onSuccess: (_, variables) => qc.invalidateQueries({ queryKey: CacheKeys.tags(variables.categoryId) }),
    })

    const updateTag = useMutation({
        mutationFn: ({categoryId, tagId, data} : {categoryId: number, tagId: number, data: UpdateCategoryInput}) => tagsService.update(categoryId, tagId, data),
        onSuccess: (_, variables) => qc.invalidateQueries({ queryKey: CacheKeys.tags(variables.categoryId) }),
    })
    
    const deleteTag = useMutation({
        mutationFn: ({categoryId, tagId} : {categoryId: number, tagId: number}) => tagsService.delete(categoryId, tagId),
        onSuccess: (_, variables) => qc.invalidateQueries({ queryKey: CacheKeys.tags(variables.categoryId) }),
    })

    return { createTag, updateTag, deleteTag }
}